var i,n;!function(i){i.IMG="img",i.ICON="icon",i.TEXT="text"}(i||(i={})),function(i){i.SMALL="small",i.MEDIUM="medium",i.LARGE="large"}(n||(n={}));export{n as AvatarSize,i as AvatarType};
//# sourceMappingURL=AvatarConstants.js.map
